import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";
import Anatomy from "../../Docs/Components/MasterDetail/MasterDetailAnatomy.mdx";
import Usage from "../../Docs/Components/MasterDetail/MasterDetailUsage.mdx";

import Examples from "../../Docs/Components/MasterDetail/MasterDetailExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="Master-detail"
            description="The master-detail pattern is a flexible approach to navigating through hierarchical pages. It takes advantage of a clear drill-in experience, while providing quick navigation between siblings, and relies on the system breadcrumb and in-page 'up' buttons for navigation."
            apiSources={["azure-devops-ui/Components/MasterPanel/MasterPanel.Props.d.ts", "azure-devops-ui/Components/SingleLayerMasterPanel/SingleLayerMasterPanel.Props.d.ts", "azure-devops-ui/Components/DetailsPanel/DetailsPanel.Props.d.ts", "azure-devops-ui/Context/MasterDetailsContext.Types.d.ts"]}
            examples={Examples}
            internalLinks={{"figma":"https://www.figma.com/file/F0RrwVCis5q5THzLQAhq6GcI/Master-detail-pattern?node-id=0%3A1"}}
            status={{"design":"done","code":"done","docs":"done"}}
            anatomy={Anatomy}
            usage={Usage}
        />
    );
}
}
        
export default Page;